import React from 'react'
import PropTypes from 'prop-types'
import Breadcrumb from 'component/Breadcrumb'

const LmExpressHeader = (props) => {
  const { translate, pageName } = props

  const renderBreadcrumb = () => {
    const steps = [
      { link: '/', title: translate('mobile.home') },
      { link: '/lmexpress', title: translate('lmexpress.title') },
      { title: pageName },
    ]

    return <Breadcrumb steps={steps} />
  }

  return renderBreadcrumb()
}

LmExpressHeader.propTypes = {
  translate: PropTypes.func.isRequired,
  pageName: PropTypes.string,
}

export default LmExpressHeader
